import React, { useState, useEffect } from "react";
import View from 'src/components/view';
import Element from 'src/components/element';
import utils from 'src/components/utils';
import DateFnsUtils from "@date-io/date-fns";

function RelatorioAscendenciaGenealogica() {
  let [view, setView] = useState({});
  let [crud, setCrud] = useState({ data: {}, changed: {}, requireds: {} });
  let dataUtils = new DateFnsUtils();

  const reportCfg = {
    label: utils.lng('ascendencia_genealogica', "Ascendência Genealógica"),
    name: 'reportCfg',
    add: false,
    print:true,
    type: 'list',
    list: {
      url: 'report_ascendenciaGenealogica'
    },
    filters: {
      date: {
        type: 'date',
        range: true,
        dateFormat: 'long',
        label: utils.lng("data_registro_penn", "Data Registro Penn"),
        default: { 
          start: dataUtils.startOfMonth(new Date()),//null 
          end: dataUtils.endOfMonth(new Date())//null 
        }
      },
      id_cliente: {
        type: 'entity',
        entity: 'Cliente',
        label: utils.lng('cliente', "Cliente"),
        list: { url: utils.getUser().administrativo === true || (utils.getUser().tipo+'').indexOf('ADMINISTRATIVO') > -1 ? 'endpoint_listar_all_clientes' : 'endpoint_listar_clientes_minha_rede' },
        itemLabel: 'nome',
        itemValue: 'id'
      },
      id_graduacao: {
        type: 'complete',
        label: utils.lng('graduacao', "Graduação"),
        list: { url: 'Graduacao' },
        itemLabel: 'descricao',
        itemValue: 'id'
      },
      id_status_penn: {
        type: 'select',
        label: utils.lng('status_penn', "Status Penn"),
        list: { url: 'StatusPenn' },
        itemLabel: 'descricao',
        itemValue: 'id'
      }
    },
    columns: {
      arvoreGeracoes: { field: 'arvore_geracao', label: utils.lng("arvore_geracoes", "Árvore de Gerações"), filter: true, sort: false },
      codigo: { field: 'codigo_mundial', label: utils.lng("codigo", "Código"), filter: true, sort: false },
      nome: { field: 'nome_cliente', label: utils.lng("nome", "Nome"), filter: false, sort: false },
      graduacao: { field: 'graduacao', label: utils.lng("graduacao", "Graduação"), filter: false, sort: false },
      filial: { field: 'filial', label: utils.lng("filial", "Filial"), filter: false, sort: false },
      statusPenn: { field: 'status_penn', label: utils.lng("status_penn", "Status Penn"), filter: false, sort: false },
      dataRegistroPenn: { field: 'data_registro_penn', type: 'date', label: utils.lng("data_registro_penn", "Data Registro Penn"), filter: false, sort: false }
    }
  };
  return (
    <View className="ui-view-report" name="rel-ascendencia-genealogica">
      <Element value={reportCfg} crud={crud} data={crud.data} view={view} ></Element>
    </View>
  );
}

export default RelatorioAscendenciaGenealogica;